export var VIEWS;
(function (VIEWS) {
    VIEWS["YEAR"] = "year";
    VIEWS["MONTH"] = "month";
    VIEWS["WEEK"] = "basicWeek";
    VIEWS["DAY"] = "basicDay";
})(VIEWS || (VIEWS = {}));
export const TOOLBAR__CSS_CLASS__VIEW__MAP = {
    year: 'period-year',
    month: 'period-month',
    basicWeek: 'period-week',
    basicDay: 'period-day',
};
export const MONTHS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];
export const FULL_MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
export var FILTER_TYPE;
(function (FILTER_TYPE) {
    FILTER_TYPE["CAMPUS"] = "CAMPUS";
    FILTER_TYPE["BUILDING"] = "BUILDING";
    FILTER_TYPE["ASSET_TYPE"] = "ASSET_TYPE";
    FILTER_TYPE["ASSIGNED"] = "ASSIGNED";
    FILTER_TYPE["PERIOD"] = "PERIOD";
})(FILTER_TYPE || (FILTER_TYPE = {}));
export var CALENDAR_TOOLBAR_ACTION_NAME;
(function (CALENDAR_TOOLBAR_ACTION_NAME) {
    CALENDAR_TOOLBAR_ACTION_NAME["NEXT"] = "NEXT";
    CALENDAR_TOOLBAR_ACTION_NAME["PREVIOUS"] = "PREVIOUS";
    CALENDAR_TOOLBAR_ACTION_NAME["NEXT_LIMIT_REACHED"] = "NEXT_LIMIT_REACHED";
    CALENDAR_TOOLBAR_ACTION_NAME["PREVIOUS_LIMIT_REACHED"] = "PREVIOUS_LIMIT_REACHED";
})(CALENDAR_TOOLBAR_ACTION_NAME || (CALENDAR_TOOLBAR_ACTION_NAME = {}));
export var CALENDAR_ACTION_NAME;
(function (CALENDAR_ACTION_NAME) {
    CALENDAR_ACTION_NAME["CALENDAR_CREATED"] = "CALENDAR_CREATED";
    CALENDAR_ACTION_NAME["FETCH_EVENTS"] = "FETCH_EVENTS";
    CALENDAR_ACTION_NAME["TOOLBAR_CREATED"] = "TOOLBAR_CREATED";
})(CALENDAR_ACTION_NAME || (CALENDAR_ACTION_NAME = {}));
export var TOOLBAR_LAYOUT;
(function (TOOLBAR_LAYOUT) {
    TOOLBAR_LAYOUT["WIDGET_WEEKLY"] = "WIDGET_WEEKLY";
    TOOLBAR_LAYOUT["FULLCALENDAR_YEARLY"] = "FULLCALENDAR_YEARLY";
    TOOLBAR_LAYOUT["FULLCALENDAR_MONTHLY"] = "FULLCALENDAR_MONTHLY";
})(TOOLBAR_LAYOUT || (TOOLBAR_LAYOUT = {}));
export const DEFAULT_PERIOD_OPTIONS = [
    { name: 'Year', code: VIEWS.YEAR },
    // { name: 'Quarter', code: 'Quarter' },
    { name: 'Month', code: VIEWS.MONTH },
    // { name: 'Week', code: VIEWS.WEEK },
];
export const DEFAULT_ASSIGNED_TYPE_OPTIONS = [
    { name: 'All', code: '' },
    { name: 'Assigned to Me', code: 'ASSIGNED_TO_ME' },
    { name: 'Unassigned', code: 'UNASSIGNED' },
];
export const AnnualCode = 'A';
export const SemiAnnualCode = 'SA';
export const QuarterCode = 'Q';
export const MonthCode = 'M';
export const WeeklyCode = 'W';
export const DEFAULT_FILTER_STATE = {
    view: VIEWS.YEAR,
    startDate: '',
    endDate: '',
    campusOptions: null,
    buildingOptions: null,
    assetTypeOptions: null,
    assignedOptions: [DEFAULT_ASSIGNED_TYPE_OPTIONS[0]],
};
export const DEFAULT_WEEKLY_FILTER_STATE = {
    view: VIEWS.WEEK,
    startDate: '',
    endDate: '',
    campusOptions: null,
    buildingOptions: null,
    assetTypeOptions: null,
    assignedOptions: [DEFAULT_ASSIGNED_TYPE_OPTIONS[0]],
};
export const DAYS_OF_WEEK = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
];
export const IN_PROGRESS = 'In Progress';
